<h5 nxHeadline="subsection-medium" class="align-center">{{data.title | translate}}</h5>
<form [formGroup]="parentForm" class="formClass">
  <qbe-panel-component>
    <div nxRow class="wrapper-panel-component nx-margin-top-3xl margin-box">
      <div nxCol="12, 12, 6" class="left-container">
        <div>
          <h2 class="left-container-heading">{{'consent.title' | translate}}</h2>
          <h6>
            <div *ngIf="data.required" class="required" style="font-weight:200"><span class="red">* </span>{{data.required | translate}}
            </div>
          </h6>
        </div>
        <div *ngIf="data.subHeading">
          <span class="enter-phone  translated-paragraph">{{'consent.subheading' | translate}}</span>
        </div>
        <div class="nx-margin-top-3xl">
          <qbe-illustration *ngIf="data.image" [name]="data.image" class="outer-top-element-left-illustration">
          </qbe-illustration>
        </div>
      </div>
      <div nxCol="12, 12, 6" [ngStyle]="{'padding-bottom': (data.rightPaddingBottom)}">
        <ng-container formGroupName="agreement">

          <div *ngIf="data.newFirst" class="required" style="padding-bottom: 0% !important;">
            <div *ngIf="trigger == false" >
              <div class="fixFlexConsents">
                <div style="width: 90%;">
                  {{data.newFirst | translate}}
                </div>
                <div class="chevron">
                  <button nxPlainButton type="button" (click)="readMore('trigger')">
                    <nx-icon name="chevron-down" class="nx-margin-right-xs fileTextIcon"></nx-icon>
                  </button>
                </div>
              </div>
              <nx-radio-group formControlName="agreement2" *ngIf="data.fourth" class="radio-agree">
                <!-- <nx-label class="nx-margin-bottom-m">{{data.fourth | translate}}</nx-label> -->
                <div class="horizontal-buttons">
                  <nx-radio [value]="1" class="nx-margin-bottom-m" (click)="legalAcceptance('legalAcceptance.isOnlineApplicationChecked', 'true')">{{data.yesPlease | translate}}</nx-radio>
                  <nx-radio [value]="0" class="nx-margin-left-s nx-margin-bottom-m" (click)="legalAcceptance('legalAcceptance.isOnlineApplicationChecked', 'false')">{{data.noThankYou | translate}}
                  </nx-radio>
                </div>
              </nx-radio-group>
            </div>
            <div *ngIf="trigger == true" >
              <div class="fixFlexConsents">
                <div style="width: 90%;">
                  {{data.newFirst | translate}}
                </div>
                <div class="chevron">
                  <button nxPlainButton type="button" (click)="readMore('trigger')">
                    <nx-icon name="chevron-up" class="nx-margin-right-xs fileTextIcon"></nx-icon>
                  </button>
                </div>
              </div>
              <nx-radio-group formControlName="agreement2" *ngIf="data.newFirst" class="radio-agree">
                <div class="horizontal-buttons">
                  <nx-radio [value]="1" class="nx-margin-bottom-m" (click)="legalAcceptance('legalAcceptance.isOnlineApplicationChecked', 'true')">{{data.yesPlease | translate}}</nx-radio>
                  <nx-radio [value]="0" class="nx-margin-left-s nx-margin-bottom-m" (click)="legalAcceptance('legalAcceptance.isOnlineApplicationChecked', 'false')">{{data.noThankYou | translate}}
                  </nx-radio>
                </div>
              </nx-radio-group>
              <div style="width: 95%;">
                {{data.newThird | translate}}
              </div>
              <div class="lower-border-button">
                <button nxPlainButton type="button" (click)="readMore('B1')">
                  <span class="readMore">{{data.readMore | translate}}</span>
                </button>
              </div>
            </div>
          </div>

          <div *ngIf="data.newFirst" class="lineCustom">
          </div>

          <div *ngIf="data.newSecond" class="required">
            <div *ngIf="trigger1 == false && over14days===false" style="padding-top: 24px;">
              <div class="fixFlexConsents">
                <div style="width: 90%;" *ngIf="over14days===false">
                  {{data.newSecond | translate}}<span class="red">* </span>
                </div>
                <div *ngIf="over14days===true" style="width: 90%;">
                  <b>{{data.additionalInfo | translate}}</b> 
                </div>

                <div class="chevron">
                  <button nxPlainButton type="button" (click)="readMore('trigger1')">
                    <nx-icon name="chevron-down" class="nx-margin-right-xs fileTextIcon"></nx-icon>
                  </button>
                </div>
              </div>
              <nx-checkbox class="checkbox" formControlName="question1" *ngIf="over14days===false"
              (click)="legalAcceptance('legalAcceptance.isTermsAndConditionsChecked', !parentForm.controls.agreement.controls.question1.value)">{{data.yesIDo |
                translate}}
              </nx-checkbox>
            </div>

            <div *ngIf="(trigger1 == true && over14days===false) || (trigger1 == false && over14days===true)" style="padding-top: 24px;">
              <div class="fixFlexConsents" *ngIf="over14days===false">
                <div *ngIf="over14days===false" style="width: 90%;">
                  {{data.newSecond | translate}}<span class="red">* </span>
                </div>

                <!-- <div *ngIf="over14days===true" style="width: 90%;">
                 <b>{{data.additionalInfo | translate}}</b> 
                </div> -->

                <div class="chevron" *ngIf="over14days===false">
                  <button nxPlainButton type="button" (click)="readMore('trigger1')">
                    <nx-icon name="chevron-up" class="nx-margin-right-xs fileTextIcon"></nx-icon>
                  </button>
                </div>
              </div>
              <nx-checkbox  class="checkbox" formControlName="question1" *ngIf="over14days===false && trigger1 != true"
              (click)="legalAcceptance('legalAcceptance.isTermsAndConditionsChecked',  !parentForm.controls.agreement.controls.question1.value)">{{data.yesIDo |
                translate}}
              </nx-checkbox>
  


              <div>
                <p *ngIf="over14days===false"> {{data.newSecond1 | translate}}</p>
                  <!-- <p style="margin-top: 2rem;" [innerHtml]="data.newSecond12 | translate | safeHtml"></p> -->

                  <!-- <ul style="margin-left: 2rem;">
                    <li>{{data.newSecond2 | translate}}</li>
                    <li> {{data.newSecond3 | translate}}</li>
                  </ul> -->

                  <p>
                    <span>{{'consent.iWantToInsureText' | translate}}</span>
                    <span *ngIf="!(hasRegistration )">{{'consent.myAllianzAgreementText' | translate}}</span>
                    <span>{{'consent.haveReadConfText' | translate}}</span>
                    </p>
                  
                  <ul style="margin-left: 2rem;">
                    <li> {{data.productDetails2 | translate}}</li>
                    <li> {{data.productDetails3 | translate}}</li>
                    <li> {{data.productDetails4 | translate}}</li>
                    <li *ngIf="!(hasRegistration )"> {{'consent.productDetails6' | translate}}</li>
                    <li> {{data.productDetails5 | translate}}</li>
                  </ul>

                  <div style="margin-top: 2rem;">
                    <button nxPlainButton type="button" (click)="readMore('B2')">
                      <span class="readMore">{{data.readMore | translate}}</span>
                    </button>
                  </div>
            

                  <nx-checkbox value="true" class="checkbox" formControlName="question1" style="margin-top: 2rem;"
                  (check)="trackService.addAttribute('legalAcceptance.isTermsAndConditionsChecked', 'true')">{{data.yesIDo |
                    translate}}
                  </nx-checkbox>
              </div>

            </div>
          </div>


        </ng-container>

      </div>
    </div>
  </qbe-panel-component>
</form>
